"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = require("styled-components");

var Icon_1 = require("../../Icon/Icon");

var LoadingIndicator_1 = require("../../LoadingIndicator/LoadingIndicator");

var styled_1 = require("../../styled");

var ButtonIconPosition_enum_1 = require("./ButtonIconPosition.enum");

var ButtonType_enum_1 = require("./ButtonType.enum");

var styled_2 = require("./styled");

var Button =
/** @class */
function (_super) {
  __extends(Button, _super);

  function Button(props) {
    var _this = _super.call(this, props) || this;

    _this.handlePress = function () {
      if (!_this.props.disabled) {
        _this.props.onPress();
      }
    };

    _this.renderIcon = function () {
      var icon = _this.props.icon;

      if (icon && icon.renderFunction) {
        return icon.renderFunction();
      }

      return react_1.default.createElement(styled_2.IconContainer, {
        position: icon.position
      }, react_1.default.createElement(Icon_1.Icon, {
        name: icon.name,
        size: icon.size,
        color: icon.color
      }));
    };

    return _this;
  }

  Button.prototype.render = function () {
    var _a = this.props,
        type = _a.type,
        text = _a.text,
        disabled = _a.disabled,
        customColor = _a.customColor,
        icon = _a.icon,
        uppercase = _a.uppercase,
        loading = _a.loading,
        theme = _a.theme,
        size = _a.size;

    if (type === ButtonType_enum_1.ButtonTypeEnum.link) {
      return react_1.default.createElement(react_native_1.TouchableWithoutFeedback, {
        onPress: this.handlePress,
        disabled: disabled,
        accessibilityLabel: text
      }, react_1.default.createElement(styled_1.RowCentered, null, loading && react_1.default.createElement(LoadingIndicator_1.LoadingIndicator, {
        size: "small",
        theme: theme
      }), !loading && icon && icon.position === ButtonIconPosition_enum_1.ButtonIconPositionEnum.left && this.renderIcon(), react_1.default.createElement(styled_2.StyledLinkText, {
        customColor: customColor,
        uppercase: !!uppercase
      }, text), !loading && icon && icon.position === ButtonIconPosition_enum_1.ButtonIconPositionEnum.right && this.renderIcon()));
    }

    return react_1.default.createElement(styled_2.ButtonOuterContainer, {
      type: type,
      disabled: disabled
    }, react_1.default.createElement(styled_2.ButtonContainer, {
      onPress: this.handlePress,
      type: type,
      size: size
    }, react_1.default.createElement(styled_1.RowCentered, null, loading && react_1.default.createElement(LoadingIndicator_1.LoadingIndicator, {
      size: "small",
      theme: theme
    }), !loading && icon && icon.position === ButtonIconPosition_enum_1.ButtonIconPositionEnum.left && this.renderIcon(), react_1.default.createElement(styled_2.ButtonText, {
      customColor: customColor,
      uppercase: uppercase
    }, text), !loading && icon && icon.position === ButtonIconPosition_enum_1.ButtonIconPositionEnum.right && this.renderIcon())));
  };

  return Button;
}(react_1.default.Component);

exports.default = styled_components_1.withTheme(Button);